import { render } from "./PageItem.vue?vue&type=template&id=b466f6a0"
import script from "./PageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PageItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/admin/js/cms/PageItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b466f6a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b466f6a0', __exports__)) {
    api.reload('b466f6a0', __exports__)
  }
  
  module.hot.accept("./PageItem.vue?vue&type=template&id=b466f6a0", () => {
    api.rerender('b466f6a0', render)
  })

}


export default __exports__